var _circle, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRupeesIba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    fill: "#1C74D0",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1471_2410)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.5005,
    cy: 43.5,
    r: 35.0122,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9859 60.0977C45.5859 60.0977 45.2693 60.0143 45.0359 59.8477C44.8026 59.681 44.5859 59.481 44.3859 59.2477L32.9359 46.1477C32.6693 45.881 32.4859 45.6477 32.3859 45.4477C32.3193 45.2143 32.2859 44.8643 32.2859 44.3977V43.2977C32.2859 42.9643 32.3859 42.6977 32.5859 42.4977C32.8193 42.2643 33.1026 42.1477 33.4359 42.1477H36.1359C38.4693 42.1477 40.2526 41.8477 41.4859 41.2477C42.7193 40.6477 43.5526 39.8477 43.9859 38.8477C44.4526 37.8477 44.6859 36.6977 44.6859 35.3977C44.6859 34.1643 44.4526 33.0477 43.9859 32.0477C43.5526 31.0143 42.7526 30.1977 41.5859 29.5977C40.4193 28.9977 38.7693 28.6977 36.6359 28.6977H32.9859C32.6526 28.6977 32.3693 28.5977 32.1359 28.3977C31.9359 28.1643 31.8359 27.881 31.8359 27.5477V26.2477C31.8359 25.9143 31.9359 25.6477 32.1359 25.4477C32.3693 25.2143 32.6526 25.0977 32.9859 25.0977H52.8859C53.2193 25.0977 53.4859 25.2143 53.6859 25.4477C53.9193 25.6477 54.0359 25.9143 54.0359 26.2477V27.5477C54.0359 27.881 53.9193 28.1643 53.6859 28.3977C53.4859 28.5977 53.2193 28.6977 52.8859 28.6977H45.2859L44.0359 27.3477C46.2026 27.881 47.6859 28.8977 48.4859 30.3977C49.2859 31.8977 49.6859 33.631 49.6859 35.5977C49.6859 37.431 49.2859 39.1143 48.4859 40.6477C47.7193 42.181 46.4859 43.4143 44.7859 44.3477C43.1193 45.2477 40.9693 45.731 38.3359 45.7977L36.8359 45.8477L36.8859 43.8477L49.6859 58.5477C49.9526 58.8143 50.0859 59.0643 50.0859 59.2977C50.0859 59.5643 49.9859 59.7643 49.7859 59.8977C49.5859 60.031 49.3359 60.0977 49.0359 60.0977H45.9859ZM32.9859 36.6977C32.6193 36.6977 32.3359 36.5977 32.1359 36.3977C31.9359 36.1977 31.8359 35.9143 31.8359 35.5477V34.2977C31.8359 33.931 31.9359 33.6477 32.1359 33.4477C32.3693 33.2477 32.6526 33.1477 32.9859 33.1477H52.8859C53.2193 33.1477 53.4859 33.2477 53.6859 33.4477C53.9193 33.6477 54.0359 33.931 54.0359 34.2977V35.5477C54.0359 35.9143 53.9193 36.1977 53.6859 36.3977C53.4859 36.5977 53.2193 36.6977 52.8859 36.6977H32.9859Z",
    fill: "#1C74D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1471_2410",
    x: 4.48828,
    y: 4.48779,
    width: 78.0234,
    height: 78.0244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.454902 0 0 0 0 0.815686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1471_2410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1471_2410",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeesIba);
export default __webpack_public_path__ + "static/media/rupees-iba.847900a94c793e041a9e97da093262f2.svg";
export { ForwardRef as ReactComponent };